import { APIResponse } from "services/HttpService";
import { PlotDataEx } from "components/dashboard/charts/interfaces";
import { formatDate } from "utils/time-utils";
import { DatasetDataInfoResponse } from "../../../../api/model/dataset/DatasetDataInfoResponse";

interface DatasetOptions {
  identifier: string;
  color?: string;
  overriddenTitle?: string;
}

export const APIResponseToDatasetDataInfoResponseArray = (
  res: APIResponse<any>,
  datasetOptions: DatasetOptions[],
  dateFormatPattern?: string
): PlotDataEx[] => {
  const resultData = res.data;
  if (!resultData || (resultData && resultData.length === 0)) {
    return [];
  }

  return DatasetDataInfoResponseArrayToPlotDataExArray(resultData, datasetOptions, dateFormatPattern);
};

export const DatasetDataInfoResponseArrayToPlotDataExArray = (
  data: DatasetDataInfoResponse[] | undefined,
  datasetOptions: DatasetOptions[],
  dateFormatPattern?: string
): PlotDataEx[] => {
  const d = data?.map((dataInfo: DatasetDataInfoResponse) => {
    const unit = ` ${dataInfo.unit as string}` || "";

    if (dataInfo.data.length === 0) {
      return undefined;
    }

    const extractedData = dataInfo.data.map((val) => {
      let date;
      try {
        date = formatDate(val.key, dateFormatPattern);
      } catch (e) {
        console.error("Error parsing date: ", e);
        date = new Date(val.key);
      }
      return { x: date, y: val.value.toFixed(1) };
    });

    const options = datasetOptions?.find(opt => opt.identifier === dataInfo.identifier) || {} as DatasetOptions;
    
    return {
      x: extractedData.map((e) => e.x),
      y: extractedData.map((e) => e.y),
      unit,
      type: 'bar',
      hovertemplate: `%{y}${unit} at %{x}<br>${options.overriddenTitle || dataInfo.title}<extra></extra>`,
      text: extractedData.map((e) => e.y.toString()),
      name: options.overriddenTitle || dataInfo.title,
      marker: { color: options.color },
    } as PlotDataEx;
  });

  return d ? d.filter((e) => e !== undefined) as PlotDataEx[] : [];
};
